import { MenuOption } from '@monorepo/shared/componentsV2/menus/Menu';
import { compose, hasAtLeastOneValue } from '@monorepo/shared/utils/validators';
import { NO_PERMISSION_TOOLTIP } from './sharedUtils';

export function getValidateNextAssigneeIds(previousAssigneeId: string) {
  return compose(hasAtLeastOneValue, (value?: string[]) =>
    value?.length === 1 && value[0] === previousAssigneeId
      ? 'Select at least one user other than the current assignee'
      : undefined,
  );
}

type ReassignTasksActionParams = {
  canReassignTasks: boolean;
  onReassignTasks: () => void;
};

export function getReassignTasksAction({
  canReassignTasks,
  onReassignTasks,
}: ReassignTasksActionParams): MenuOption {
  return {
    displayName: 'Reassign tasks',
    onClick: onReassignTasks,
    disabled: !canReassignTasks,
    tooltip: canReassignTasks ? '' : NO_PERMISSION_TOOLTIP,
  };
}
